import { render, staticRenderFns } from "./StudentsEditDataPersonal.vue?vue&type=template&id=73007a92&scoped=true&"
import script from "./StudentsEditDataPersonal.vue?vue&type=script&lang=js&"
export * from "./StudentsEditDataPersonal.vue?vue&type=script&lang=js&"
import style0 from "./StudentsEditDataPersonal.vue?vue&type=style&index=0&id=73007a92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73007a92",
  null
  
)

export default component.exports